import { Button } from "antd";
import VideoRule from "./BankRuls";

const VideoButton = ({
  className = "",
  classNameBtn = "",
  disabled,
  loading = false,
  name,
  onNextStep,
  tryAgain,
  rules,
  onChangeRules,
}) => {
  return (
    <div className={`p-5 fixed  bottom-0 w-full max-w-2xl  ${className}`}>
      {tryAgain && <VideoRule value={rules} onChangeRules={onChangeRules} />}
      <Button
        block
        className={`primary-button-large justify-center items-center ${classNameBtn}`}
        disabled={disabled}
        loading={loading}
        onClick={onNextStep}
      >
        {name}
      </Button>
    </div>
  );
};
export default VideoButton;
